export const FONT_DEFAULT_SIZE = 20;
export const FONT_DEFAULT_FAMILY = 'Helvetica, Arial, sans-serif';
export const FONT_DEFAULT_COLOR = '#000000';
export const DEFAULT_EMPTY_WIDTH = 100; // CSS px
export const LINE_HEIGHT_MULT = 1.2;
export const DRAG_START_THRESHOLD = 4;
